(() => {
  const templateId = "gc-country-options-template";
  let instanceIndex = 0;

  const bind = (root = document) => {
    root.querySelectorAll("x-listbox[data-gc-country-options]:not([data-gc-country-bound])").forEach((listbox) => {
      const popover = listbox.closest("x-popover");

      if (!popover) {
        return;
      }

      listbox.dataset.gcCountryBound = "true";

      const hydrate = () => {
        if (listbox.dataset.gcCountryHydrated === "true") {
          return;
        }

        const template = document.getElementById(templateId);

        if (!template) {
          return;
        }

        const idPrefix = `gc-country-${instanceIndex++}`;
        listbox.append(template.content.cloneNode(true));

        listbox.querySelectorAll('[role="option"]').forEach((option, index) => {
          option.id = `${idPrefix}-${index}`;
        });

        const selectedOption = listbox.querySelector('[aria-selected="true"]');

        if (selectedOption) {
          listbox.setAttribute("aria-activedescendant", selectedOption.id);
        }

        listbox.dataset.gcCountryHydrated = "true";
      };

      popover.addEventListener("dialog:before-show", hydrate, { once: true });

      if (popover.hasAttribute("open")) {
        hydrate();
      }
    });
  };

  bind();
  document.addEventListener("shopify:section:load", (event) => bind(event.target));
})();
